import CertificateAndPaymentInfo from "components/application/CertificateAndPaymentInfo";

export const SubmittedContract = () => {
  return <CertificateAndPaymentInfo />;
};
